export default "__VITE_ASSET__BHX80Mh6__"